import { CategoryQueue } from '../types'

export const checkPercentageVisibilityForCategory = ({
  categoryApplicableForQueue,
  withinOpenHours,
  targetPercentage,
}: {
  categoryApplicableForQueue: CategoryQueue
  withinOpenHours: boolean
  targetPercentage: number
}): boolean => {
  if (categoryApplicableForQueue === null) return false
  const sessionChatTargetDemographic = sessionStorage.getItem('chatTargetDemographic')

  if (sessionChatTargetDemographic !== null) {
    return processCurrentSessionChatDemographic({
      sessionChatTargetDemographic,
      categoryApplicableForQueue,
      targetPercentage,
      withinOpenHours,
    })
  }

  const isSessionWithinTargetPercentage = calculateVisibilityBasedOnTarget(targetPercentage)

  const chatTargetDemographic = {
    [categoryApplicableForQueue]: { isSessionWithinTargetPercentage, targetPercentage, withinOpenHours },
  }

  sessionStorage.setItem('chatTargetDemographic', JSON.stringify(chatTargetDemographic))

  return isSessionWithinTargetPercentage && withinOpenHours
}

const processCurrentSessionChatDemographic = ({
  sessionChatTargetDemographic,
  categoryApplicableForQueue,
  targetPercentage,
  withinOpenHours,
}: {
  sessionChatTargetDemographic: string
  categoryApplicableForQueue: string
  targetPercentage: number
  withinOpenHours: boolean
}): boolean => {
  const previousChatTargetDemographic = JSON.parse(sessionChatTargetDemographic)

  if (
    previousChatTargetDemographic?.[categoryApplicableForQueue]?.targetPercentage === targetPercentage &&
    previousChatTargetDemographic?.[categoryApplicableForQueue]?.withinOpenHours === withinOpenHours
  ) {
    // respect the previous role from session data if there has been no change to the targeted percentage and opening hours
    return (
      (previousChatTargetDemographic?.[categoryApplicableForQueue]?.isSessionWithinTargetPercentage &&
        previousChatTargetDemographic?.[categoryApplicableForQueue]?.withinOpenHours) ??
      false
    )
  }
  // if target percentage has changed re-roll the visibility
  const isSessionWithinTargetPercentage = calculateVisibilityBasedOnTarget(targetPercentage)
  const newChatTargetDemographic = {
    ...previousChatTargetDemographic,
    [categoryApplicableForQueue]: { isSessionWithinTargetPercentage, targetPercentage, withinOpenHours },
  }
  sessionStorage.setItem('chatTargetDemographic', JSON.stringify(newChatTargetDemographic))

  return isSessionWithinTargetPercentage && withinOpenHours
}

const calculateVisibilityBasedOnTarget = (targetPercentage: number) => {
  let isSessionWithinTargetPercentage = false

  if (targetPercentage === 100) {
    isSessionWithinTargetPercentage = true
  }

  if (targetPercentage === 0) {
    isSessionWithinTargetPercentage = false
  }

  if (targetPercentage !== 0 && targetPercentage !== 100) {
    const diceRoll = Math.floor(Math.random() * 100) + 1
    isSessionWithinTargetPercentage = diceRoll >= 100 - targetPercentage
  }
  return isSessionWithinTargetPercentage
}
